/**
 * @file Form Text component
 */

import Quill from 'quill';

/**
 * Form Text component
 */
const vFormText = () => {
    const formText = document.querySelector( '.v-form-text' );

    if ( !formText ) {
        return;
    }

    const scrollingContainer = formText.querySelector( '.v-form-text__scrolling-quill-container' );
    const quillContainer     = formText.querySelector( '.v-form-text__quill-container' );
    const submitButton       = formText.querySelector( '.v-form-text__submit-btn' );
    const form               = formText.querySelector( '.v-form-text__form' );
    const hiddenInput        = formText.querySelector( '.v-form-text__hidden-input' );
    const existingContent    = quillContainer.getAttribute( 'data-existing' );

    const quill = new Quill( quillContainer, {
        theme: 'snow',
        modules: {
            toolbar: [
                [ { header: [ 2, 3, false ] } ],
                [ 'bold', 'italic', 'underline' ],
                [ 'link', 'blockquote', 'code-block' ],
                [ { list: 'ordered' }, { list: 'bullet' } ],
                [ 'image', 'code-block' ],
            ],
        },
        scrollingContainer,
        placeholder: quillContainer.getAttribute( 'data-placeholder' ),
        theme: 'bubble',
        readOnly: quillContainer.hasAttribute( 'data-readonly' ),
    });

    if ( existingContent.length > 0 ) {
        quill.setContents( JSON.parse( existingContent ) );
    }

    if ( ! quillContainer.hasAttribute( 'data-readonly' ) ) {
        quill.on('text-change', (delta, oldDelta, source) => {
            if (source === 'user' && submitButton.hasAttribute( 'disabled' )) {
                submitButton.removeAttribute( 'disabled' );
            }
        });

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            hiddenInput.value = JSON.stringify( quill.getContents() );

            form.submit();
        });
    }
};

export default vFormText;
